






import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import SubscriptionsTable from './SubscriptionsTable.vue';

@Component({
  name: 'subscriptions',
  components: {
    SubscriptionsTable
  }
})
export default class Subscriptions extends Vue {}
